export default "__VITE_PUBLIC_ASSET__dcd2db20__"